import YourDetails from './YourDetails';

export default YourDetails;
